module.exports = __webpack_public_path__ + "static/media/ship.87ea918a.gif";